// @ts-check

/**
 * The org profile starts clean on a fresh arrival and keeps its filters when the
 * user comes back to it — Back, Forward or a reload. Telling the two apart by
 * the router's last action is unreliable: the page asks from its mount effect,
 * which can run inside react-router's own history listener, before anything else
 * has heard about the navigation.
 *
 * So the page marks the history entry instead. On mount it stamps the entry's
 * state with the org id. A Back, Forward or reload lands on an entry that still
 * carries the stamp — browsers keep history state across all three — while any
 * link, typed URL, bookmark or new tab creates an entry without one. Nothing is
 * put in the URL, so a link can never carry anyone's filters.
 */
export const ORG_ENTRY_STATE_KEY = 'orgProfileEntry';

/**
 * Whether this history entry is one the org page has already been on.
 * @param {any} state the location's state
 * @param {string | number} organisationId
 * @returns {boolean}
 */
export const isReturnToOrgEntry = (state, organisationId) =>
  state?.[ORG_ENTRY_STATE_KEY] != null &&
  String(state[ORG_ENTRY_STATE_KEY]) === String(organisationId);

/**
 * The location to replace the current one with so the entry is marked as this
 * org's. Keeps the path, query, hash and any state already there.
 * @param {{ pathname: string, search?: string, hash?: string, state?: any }} location
 * @param {string | number} organisationId
 */
export const stampOrgEntry = (location, organisationId) => ({
  ...location,
  state: { ...location.state, [ORG_ENTRY_STATE_KEY]: String(organisationId) },
});
